import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { copyFor } from '../../copy/copy';

const MailIcon = props => (
    <svg
        width={props.isMobileResolution ? 52 : 36}
        height={props.isMobileResolution ? 52 : 36}
        viewBox="0 -9 16 33"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'mail')}</title>
        <path
            d="M8,10c-0.266,0-0.5-0.094-1-0.336L0,6v7c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V6L9,9.664C8.5,9.906,8.266,10,8,10z M15,2  H1C0.45,2,0,2.45,0,3v0.758l8,4.205l8-4.205V3C16,2.45,15.55,2,15,2z"
            fillRule="evenodd"
            fill="#000"
        />
    </svg>
);

MailIcon.propTypes = {
    isMobileResolution: PropTypes.bool.isRequired
};

export default connect(
    state => ({
        isMobileResolution: state.widget.isMobileResolution
    }),
    {}
)(MailIcon);
